import axios from "../service/HttpRequestBibomart";


function  getCategories(parent_id, level, position){
        let param = '?1=1';
        if(parent_id !== ''){
            param= param+'&parent_id='+parent_id;
        }
        if(level !== ''){
            param= param+'&level='+level;
        }
        if(position !== ''){
            param= param+'&position='+position;
        }
        return  axios.get('/categories/getcategories'+param);
    }
    function getMetaCategory(uri){
        return axios.get('/categories/getcategoriesmeta?uri_key='+uri);
    }
    function getProductByCategory(uri, page, pagesize, min_price, max_price){
        let param = '';
        if(page !== ''){
            param= param+'&page='+page;
        }
        if(pagesize !== ''){
            param= param+'&page_item='+pagesize;
        }
        if(min_price !== ''){
            param= param+'&min_price='+min_price;
        }
        if(max_price !== ''){
            param= param+'&max_price='+max_price;
        }
        return  axios.get('/products/getproductbycategory?uri_key='+uri+param);
    }

    function getProductMetaKey(sku, store){
        return  axios.get('/products/getproductmetakey?sku='+sku+'&store_id='+store);
    }

    function getBrand(uri){
        return  axios.get('/brands/getbrand?url='+uri);
    }

    function getProductByBrand(uri, page, pagesize, min_price, max_price){
        let param = '';
        if(page !== ''){
            param= param+'&page='+page;
        }
        if(pagesize !== ''){
            param= param+'&page_item='+pagesize;
        }
        if(min_price !== ''){
            param= param+'&min_price='+min_price;
        }
        if(max_price !== ''){
            param= param+'&max_price='+max_price;
        }
        return  axios.get('/products/getproductbybrand?uri_key='+uri+param);
    }

export {
    getCategories,getMetaCategory,getProductByCategory,getProductMetaKey,getBrand,getProductByBrand
}